module.exports = __webpack_public_path__ + "static/media/icn_diseases_insurance.605cd92a.svg";